import { render } from "./PaymentFailed.vue?vue&type=template&id=9a65a534&ts=true"
import script from "./PaymentFailed.vue?vue&type=script&lang=ts"
export * from "./PaymentFailed.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__